/**
 * Offline Package Loader
 * Loads packages from local files instead of CDN for offline functionality
 */

class OfflinePackageLoader {
  constructor() {
    this.loadedPackages = new Set();
  }

  /**
   * Load html2pdf.js from local file
   * @returns {Promise}
   */
  loadHtml2Pdf() {
    return new Promise((resolve, reject) => {
      if (window.html2pdf && this.loadedPackages.has('html2pdf')) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
      script.onload = () => {
        this.loadedPackages.add('html2pdf');
        resolve();
      };
      script.onerror = () => {
        console.error('Failed to load html2pdf.js from local file');
        reject(new Error('Failed to load html2pdf.js'));
      };
      document.head.appendChild(script);
    });
  }

  /**
   * Check if html2pdf is available
   * @returns {boolean}
   */
  isHtml2PdfAvailable() {
    // Check if html2pdf exists and is not the placeholder
    if (!window.html2pdf || typeof window.html2pdf !== 'function') {
      return false;
    }
    
    // Check if it's the placeholder implementation
    const testInstance = window.html2pdf();
    if (testInstance && testInstance.set && testInstance.from && testInstance.save) {
      // Try to detect if it's a placeholder by checking for console.warn in the save method
      const saveMethod = testInstance.save.toString();
      if (saveMethod.includes('console.warn') || saveMethod.includes('not loaded')) {
        return false;
      }
      return true;
    }
    
    return false;
  }

  /**
   * Load all required packages for Contracts
   * @returns {Promise}
   */
  async loadContractsPackages() {
    try {
      await this.loadHtml2Pdf();
      return true;
    } catch (error) {
      console.error('Failed to load packages for Contracts:', error);
      return false;
    }
  }

  /**
   * Load all required packages for Ownership
   * @returns {Promise}
   */
  async loadOwnershipPackages() {
    try {
      await this.loadHtml2Pdf();
      return true;
    } catch (error) {
      console.error('Failed to load packages for Ownership:', error);
      return false;
    }
  }
}

// Create singleton instance
const offlinePackageLoader = new OfflinePackageLoader();

export default offlinePackageLoader;